import React from 'react';
import { TextInput, Select, Checkbox, Button } from 'react-materialize';
function Contact() {
    return (
        <React.Fragment>
            <section className='filter'>
                <br />
                <div className='title-principal'>
                    <h1>Contact</h1>
                    <p>connect with us, and solve any concern you have.</p>
                </div>
                <br />

                <form>

                    <TextInput
                        data-length={20}
                        id="TextInput-27"
                        label="Name"
                    />
                    <TextInput
                        email
                        id="TextInput-74"
                        label="Email"
                        validate
                    />

                    <Select
                        id="Select-86"
                        multiple={false}
                        onChange={function noRefCheck() { }}
                        options={{
                            classes: '',
                            dropdownOptions: {
                                alignment: 'left',
                                autoTrigger: true,
                                closeOnClick: true,
                                constrainWidth: true,
                                coverTrigger: true,
                                hover: false,
                                inDuration: 150,
                                onCloseEnd: null,
                                onCloseStart: null,
                                onOpenEnd: null,
                                onOpenStart: null,
                                outDuration: 250
                            }
                        }}
                        value=""
                    >
                        <option
                            disabled
                            value=""
                        >
                            Select what motivates you to learn
                        </option>
                        <option value="1">
                            Meditation
                        </option>
                        <option value="2">
                            Relaxation
                        </option>
                        <option value="3">
                            Health
                        </option>
                        <option value="4">
                            All benefits
                        </option>
                    </Select>

                    <Checkbox
                        id="Checkbox_1"
                        label="Are you new to yoga?"
                        value="yes"
                    />

                    <Button
                        href="https://devgrimaldo.com/"
                        node="a"
                        style={{
                            marginRight: '5px'
                        }}
                        waves="light"

                    >
                        button
                    </Button>
                </form>
                <br/>
            </section>
        </React.Fragment>
    );
}
export default Contact;